import { Table } from 'shared/components'

export const createColumns = () => [
  {
    Header: 'Amount',
    accessor: 'amount',
    Cell: Table.CellRenderers.MoneyValueCell,
    minWidth: 136,
    style: { textAlign: 'right', paddingRight: '1rem' },
  },
  {
    Header: 'Date',
    accessor: 'time',
    Cell: Table.CellRenderers.NewDateCell,
    minWidth: 136,
  },
  {
    Header: 'Card',
    accessor: 'stripePaymentDTO.brandLogo',
    Cell: Table.CellRenderers.PaymentMethodCell,
    width: 110,
  },
  {
    Header: 'Action',
    id: 'type',
    accessor: ({ type }) => {
      const mapType = {
        INWIN_PLACE: 'InWin Placed',
        INWIN_REFUND: 'InWin Refunded',
        TOPUP: 'Balance Topped Up',
      }

      return mapType[type] || type
    },
    minWidth: 136,
  },
]
